export default "__VITE_ASSET__UVlYs3Yl__"